import { useLayoutEffect } from 'react';

export const useScrollToTop = () => {
  // scroll to top of page after a page transition.
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);
};
